<div
  class="step-section"
  [class.step-section-done]="isStepOneDone"
  [formGroup]="formGroup()"
>
  <div class="step-title">
    <span class="step-number">1</span>
    <h3>{{ 'stepOneTitle' | translate }}</h3>
  </div>
    <div class="step-fields">
    <div class="step-field">
      <app-input-dropdown
        formControlName="typeOperation"
        [id]="'operation-select'"
        [label]="'typeOperation'"
        [required]="true"
        [placeholder]="'placeholderSelectTypeOperation'"
        [items]="itemsTypeOperations()"
        [showClear]="false"
        [filter]="false"
        class="w-full"
      ></app-input-dropdown>
    </div>
    <div class="step-field">
      <label class="field-label field-required" for="policy-number">{{
        'policyNumber' | translate
      }}</label>
      <input
        pInputText
        id="policy-number"
        type="text"
        formControlName="policyNumber"
        class="policy-input w-full"
        [placeholder]="'placeholderPolicyNumber' | translate"
        autocomplete="off"
        [maxlength]="12"
      />
    </div>
  </div>
  @if (isStepOneIncomplete) {
    <div class="step-notice">
      <i class="pi pi-info-circle"></i>
      @if (showPolicyNumberError && hasPolicyNumberPatternError) {
        <span>{{ 'policyNumberOnlyNumbers' | translate }}</span>
      } @else if (showPolicyNumberError && hasPolicyNumberLengthError) {
        <span>{{ 'policyNumberExactLength' | translate }}</span>
      } @else {
        <span>{{ 'fillRequiredData' | translate }}</span>
      }
    </div>
  }
</div>
